import React from 'react';
import { InstagramIcon, YoutubeIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white pt-20 pb-8" data-id="element-406">
      <div className="container-wide" data-id="element-407">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 mb-16" data-id="element-408">
          {/* Col 1: Brand */}
          <div className="lg:col-span-4 pr-0 lg:pr-8" data-id="element-409">
            <div className="flex items-center gap-4 mb-6" data-id="element-410">
              <div className="bg-white p-3 rounded-2xl inline-block shadow-sm" data-id="element-411">
                <img src="https://cdn.magicpatterns.com/uploads/sh7d1L5p7P4qM7QsZEZJDX/logo-header.png" alt="Better Pets and Gardens" className="h-12 object-contain" data-id="element-412" />
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="h-14 w-14 rounded-full object-cover shadow-sm" data-id="element-413" />
            </div>
            <p className="text-gray-400 text-base mb-8 leading-relaxed" data-id="element-414">
              Your local experts for pets, gardens & pools. Proudly 100% WA
              owned and operated with six locations across Perth.
            </p>
            <div className="flex items-center gap-4" data-id="element-415">
              <a href="https://www.facebook.com/BetterPetsandGardens" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-gray-400 hover:bg-[#1877F2] hover:text-white transition-all hover:scale-110" aria-label="Facebook" data-id="element-416">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-417">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-418" />
                </svg>
              </a>
              <a href="#" className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-gray-400 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-500 hover:text-white transition-all hover:scale-110" aria-label="Instagram" data-id="element-419">
                <InstagramIcon className="w-5 h-5" data-id="element-420" />
              </a>
              <a href="#" className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all hover:scale-110" aria-label="YouTube" data-id="element-421">
                <YoutubeIcon className="w-5 h-5" data-id="element-422" />
              </a>
            </div>
          </div>

          {/* Col 2: Shop */}
          <div className="lg:col-span-2" data-id="element-423">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-424">
              Shop
            </h4>
            <ul className="space-y-4" data-id="element-425">
              <li data-id="element-426">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-427">
                  Dogs & Puppies
                </a>
              </li>
              <li data-id="element-428">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-429">
                  Cats & Kittens
                </a>
              </li>
              <li data-id="element-430">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-431">
                  Birds & Poultry
                </a>
              </li>
              <li data-id="element-432">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-433">
                  Fish
                </a>
              </li>
              <li data-id="element-434">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-435">
                  Small Animals
                </a>
              </li>
              <li data-id="element-436">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-437">
                  Garden Care
                </a>
              </li>
              <li data-id="element-438">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-439">
                  Pools & Spas
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Our Stores */}
          <div className="lg:col-span-2" data-id="element-440">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-441">
              Our Stores
            </h4>
            <ul className="space-y-4" data-id="element-442">
              <li data-id="element-443">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-444">
                  <MapPinIcon className="w-4 h-4" data-id="element-445" /> Caversham
                </a>
              </li>
              <li data-id="element-446">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-447">
                  <MapPinIcon className="w-4 h-4" data-id="element-448" /> Kelmscott
                </a>
              </li>
              <li data-id="element-449">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-450">
                  <MapPinIcon className="w-4 h-4" data-id="element-451" /> Malaga
                </a>
              </li>
              <li data-id="element-452">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-453">
                  <MapPinIcon className="w-4 h-4" data-id="element-454" /> Midland
                </a>
              </li>
              <li data-id="element-455">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-456">
                  <MapPinIcon className="w-4 h-4" data-id="element-457" /> Wangara
                </a>
              </li>
              <li data-id="element-458">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-459">
                  <MapPinIcon className="w-4 h-4" data-id="element-460" /> Whitfords
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Connect & Newsletter */}
          <div className="lg:col-span-4" data-id="element-461">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-462">
              Stay Connected
            </h4>
            <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700" data-id="element-463">
              <p className="text-gray-300 text-sm mb-4 leading-relaxed" data-id="element-464">
                Join our newsletter for expert tips, seasonal advice, and
                exclusive member offers.
              </p>
              <form className="mb-6" onSubmit={e => e.preventDefault()} data-id="element-465">
                <div className="relative mb-3" data-id="element-466">
                  <input type="email" placeholder="Email address" className="w-full bg-slate-900 border border-slate-600 rounded-xl py-3.5 pl-11 pr-4 text-white placeholder-gray-500 focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-all" data-id="element-467" />
                  <MailIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" data-id="element-468" />
                </div>
                <button className="w-full bg-brand-blue hover:bg-brand-blue-600 text-white font-heading font-semibold py-3.5 rounded-xl transition-colors shadow-blue-glow" data-id="element-469">
                  Subscribe
                </button>
              </form>
              <div className="flex items-center justify-center gap-3 pt-4 border-t border-slate-700" data-id="element-470">
                <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="WA Owned" className="w-6 h-6 rounded-full object-cover" data-id="element-471" />
                <span className="text-sm font-medium text-white" data-id="element-472">
                  Proudly 100% WA Owned
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-473">
          <p className="text-gray-500 text-sm" data-id="element-474">
            © 2026 Better Pets and Gardens. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-475">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-476">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-477">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-478">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>;
}